<template>
  <div>
    <div class="sayfahead tek">
      <h1>Abone Arama</h1>
    </div>
    <div class="icerik" style="height: calc(100vh + 220px) !important;">
      <div class="SpotlightKutu" style="z-index: 1">

        <div class="input">
          <el-input
            :disabled="lo"
            placeholder="Abone No yazınız"
            v-model="Kelime"
            @keyup.enter.native="Arama">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <hr>
      <AboneDetay v-if="KisiEkranModal" :Abone_id="KisiEkranModalid"></AboneDetay>
    </div>
  </div>
</template>

<script>
import AboneDetay from "./AboneDetay";

export default {
  components: {AboneDetay},
  data() {
    return {
      lo: false,
      KisiEkranModal: false,
      KisiEkranModalid: null,
      Kelime: ''
    }
  },
  methods: {
    Arama() {
      this.lo = true;
      this.KisiEkranModal = false
      this.$store.dispatch("Get", {path: '_enerji/abone/arama/' + this.Kelime})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.KisiEkranModal = true
            this.KisiEkranModalid = response.Mesken_id
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Abone/Index.vue